// extracted by mini-css-extract-plugin
module.exports = {"container":"sprintsWalkthrough_container__BWDgi","seperation-line":"sprintsWalkthrough_seperation-line__3gSY_"};